import { type DepositAccount, LINK_NEW_DEPOSIT_ACCOUNT } from '@fruitful/types';
import * as React from 'react';
import { Sheet, View, YStack } from 'smoothie';

import { useAuthedUser } from '../../../common/providers/AuthedUserProvider';
import Plaid from '../plaid/Plaid';
import TransferAccountLineItem from './TransferAccountLineItem';

interface SelectAccountSheetProps {
    isOpen: boolean;
    depositAccounts: DepositAccount[];
    onClose: () => void;
    onPlaidExit: () => void;
    onSelectAccount: (account: DepositAccount) => void;
    enableLinkingNewAccount: boolean;
    onSuccessfulPlaidLink?: () => void;
    onNeedsReview: () => void;
}

const SelectAccountSheet = ({
    isOpen,
    onClose,
    onPlaidExit,
    depositAccounts,
    onSelectAccount,
    enableLinkingNewAccount,
    onSuccessfulPlaidLink,
    onNeedsReview,
}: SelectAccountSheetProps) => {
    const user = useAuthedUser();

    return (
        <Sheet
            isOpen={isOpen}
            onClose={onClose}
            renderInAppRoot={false}
            disableDrag
            title="Select account"
            showCloseButton={true}
        >
            <YStack>
                {depositAccounts.map((account) => (
                    <View key={account.id} paddingVertical={8}>
                        <TransferAccountLineItem
                            onPress={() => {
                                onSelectAccount(account);
                                onClose();
                            }}
                            depositAccount={account}
                        />
                    </View>
                ))}
                {enableLinkingNewAccount && (
                    <Plaid
                        user={user}
                        onSuccessfulLink={onSuccessfulPlaidLink}
                        onExitLink={onPlaidExit}
                        onNeedsReview={onNeedsReview}
                    >
                        <View marginTop={8}>
                            <TransferAccountLineItem
                                depositAccount={LINK_NEW_DEPOSIT_ACCOUNT}
                            />
                        </View>
                    </Plaid>
                )}
            </YStack>
        </Sheet>
    );
};

export default SelectAccountSheet;
